import { guardNumber } from "../numbers";
import { Constants } from "./constants";

export function getArticleGroupNumberString(_number: number) {
	const number = guardNumber(_number);
	return `${Constants.ARTICLE_GROUP_NUMBER_PREFIX}${number.toString().padStart(Constants.ARTICLE_GROUP_NUMBER_PADDING, "0")}`.trim();
}
